/**
 * @file Colle native (Capacitor) : plein ecran immersif, ecran de lancement masque une fois le jeu pret, bouton « retour » Android (met l'application en
 * arriere-plan au lieu de la tuer). Sans effet dans un navigateur / la PWA ; les plugins sont charges a la demande (aucun cout hors application native).
 */
import { isNativeApp } from './pwa';

export const initNative = async (): Promise<void> => {
  if (!isNativeApp()) return;
  try {
    const [{ SplashScreen }, { StatusBar, Style }, { App }] = await Promise.all([import('@capacitor/splash-screen'), import('@capacitor/status-bar'), import('@capacitor/app')]);
    await StatusBar.setStyle({ style: Style.Dark }).catch(() => undefined);
    await StatusBar.setOverlaysWebView({ overlay: true }).catch(() => undefined);
    await StatusBar.hide().catch(() => undefined);
    await App.addListener('backButton', () => {
      // le jeu n'a pas de pile de navigation : « retour » = mettre en arriere-plan (la sauvegarde part avec la mise en veille)
      void App.minimizeApp();
    });
    await SplashScreen.hide({ fadeOutDuration: 250 });
  } catch (err) {
    console.warn('initialisation native partielle', err);
  }
};
